import { render, staticRenderFns } from "./vueMyBalance.vue?vue&type=template&id=6b6a1b54&scoped=true"
import script from "./vueMyBalance.vue?vue&type=script&lang=js"
export * from "./vueMyBalance.vue?vue&type=script&lang=js"
import style0 from "./vueMyBalance.vue?vue&type=style&index=0&id=6b6a1b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6a1b54",
  null
  
)

export default component.exports